export default __webpack_public_path__ + "static/media/sweets-20.eff6eefe.png";